export const tableLagealEntries = [
    { key: "number", value: "№"},
    { key: "name", value: "Название"},
    { key: "legalForm", value: "Правовая форма"},
    { key: "count", value: "Количество объектов"},
    { key: "startCoop", value: "Начало сотрудничества"},
   
];


